skrilla.controller('excludedUsersCtrl', function ($scope, $stateParams) {
    $scope.key = "excludedUsers";
    $scope.tabs = [
        {title: "Excluded Users", active: true},
        {title: "Excluded Persons Register", active: false},
        {title: "User Sports Exclusions", active: false},
    ];

    if($stateParams.excludedPersonId){
        $scope.selected = 1;
    }

});